import styled from 'styled-components';
export const Item = styled.li `
  display: flex; 
  padding: 0;
  margin: 0;
  
  & + & {
    margin-top: 1rem;
  }
`;
//
// ${FieldWrapper} {
//   flex: 0 1 13rem;
// }
export const Name = styled.div `
  display: block;
  flex: 1;
`;
export const Note = styled.span `
  display: block;
  margin-top: 0.5rem;
`;
export const BandsList = styled.ul `
  display: block;
  list-style: none;
  margin: 0;
  svg {
    
  }
  
  ${({ theme: { attendeeBands } }) => attendeeBands}
`;
export default {
    Item,
    Name,
    Note,
};
